import { group } from '@angular/animations';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConveniosTreeViewService } from '../../services/convenios-tree-view.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-add-convenios',
    templateUrl: './add-convenios.component.html',
    styleUrls: ['./add-convenios.component.scss'],
    standalone: false
})

export class AddConveniosComponent implements OnInit {
    selected;
    dataSourceDropdown;
    public addConvenioForm: UntypedFormGroup;
    selcted :any;
    convedropdown=true
    constructor(
        private _conveniosTreeViewService: ConveniosTreeViewService,
        private dialogRef: MatDialogRef<AddConveniosComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit(): void {
        if (this.data.isInsert) {
            this.addConvenioForm = new UntypedFormGroup({
                Grupo: new UntypedFormControl('', Validators.required),
                Nombre: new UntypedFormControl('', [Validators.required, this.noWhitespaceValidator])
            });
        }
        else {
            this.addConvenioForm = new UntypedFormGroup({
                ConvenioId: new UntypedFormControl(this.data.convenioId, Validators.required),
                Grupo: new UntypedFormControl(this.data.groupo, Validators.required),
                Nombre: new UntypedFormControl(this.data.nombre, [Validators.required, this.noWhitespaceValidator])
            });
        }
        this.loadDropdown();
    }
    public noWhitespaceValidator(control: UntypedFormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }
    public onClose(): void {
        this.dialogRef.close();
    }

    public onSave(): void {
        this.addConvenioForm.markAllAsTouched();
        this.addConvenioForm.updateValueAndValidity();
        if (this.addConvenioForm.valid) {
            if (this.data.isInsert) {
                this._conveniosTreeViewService.addConvenio(this.addConvenioForm.value).subscribe(res => {
                    if (res) {
                        this.dialogRef.close(true);
                    }
                });
            }
            else {
                this._conveniosTreeViewService.editConvenio(this.addConvenioForm.value).subscribe(res => {
                    if (res) {
                        this.dialogRef.close(this.addConvenioForm.value);
                    }
                });
            }
        }
    }

    loadDropdown() {
        this._conveniosTreeViewService.getGroups().subscribe(res => {
            if (res) {
                this.dataSourceDropdown = res;
            }
        });
    }

    selectedMenu(value)
    {
        this.addConvenioForm.patchValue({
            Grupo: value,
        });
        this.addConvenioForm.updateValueAndValidity();

        this.convedropdown=!this.convedropdown

    }

}
